"use client"

import { CART_DRAWER_OPEN_EVENT } from "@constants/cart"

/**
 * Opens the single, always-mounted CartDropdown drawer (rendered in the
 * desktop header) instead of mounting a second instance here — see the
 * comment on CartDropdown's own event listener for why.
 */
export default function MobileCartTrigger() {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event(CART_DRAWER_OPEN_EVENT))}
      className="text-gray-900 hover:opacity-70 transition-opacity p-1"
      data-testid="nav-cart-link-mobile"
      aria-label="Shopping cart"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>
    </button>
  )
}
